import React from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function Introduction() {
  return (
    <div className="Introduction">
      <br />
      <h3>Natural Hair Product Selector</h3>
      <p>
        Giving advice on caring for natural hair is a big part of what we do.
        It's an amazing feeling to help someone with something that they have
        been struggling with.
      </p>
      <p>
        We built this app to help answer the questions we get and reccommend
        solutions. We hope you can get an idea of where to go next and what
        products might help solve your problem.
      </p>
      <hr />
    </div>
  );
}

export default Introduction;
